import { NOTEBOOKS } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import NotebooksPage from "./container/NotebooksPage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.auth],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: NOTEBOOKS,
    withSidebar: false,
    withAppBar: true,
    component: NotebooksPage,
  };
}
